export default __webpack_public_path__ + "static/media/1690_1692.99a4d0d2.JPG";